// extracted by mini-css-extract-plugin
export default {"BannerText":"BannerText_BannerText__1xHjo"};